import React, { Fragment, ReactElement } from 'react';
import { classNames } from '../../util/classNames';
import { SnapIcon } from '../SnapIcon';

type Props = {
  name: string;
  stepNumber: number;
  nextStepCompleted: boolean;
  isComplete: boolean;
  isCurrent: boolean;
  isNextStep: boolean;
};

export const Step = (props: Props) => {
  const {
    stepNumber,
    name,
    nextStepCompleted,
    isComplete,
    isCurrent,
    isNextStep,
  } = props;
  const renderLine = (color: string) => (
    <div aria-hidden='true' className='absolute inset-0 flex items-center'>
      <div className={classNames('h-0.5 w-full', color)} />
    </div>
  );

  const renderIcon = (bgColor: string, icon?: ReactElement) => (
    <div
      className={classNames(
        'relative flex size-6 items-center justify-center rounded-full',
        bgColor,
      )}
    >
      {icon ? (
        icon
      ) : (
        <h4 className='text-sm font-medium text-center'>
          {stepNumber}
          <span className='sr-only'> {name}</span>
        </h4>
      )}
    </div>
  );

  if (isCurrent && isComplete && nextStepCompleted) {
    return (
      <Fragment>
        {renderLine('bg-green-600')}
        {renderIcon(
          'border bg-green-600 border-green-600',
          <h4 className='text-white text-sm font-medium text-center'>
            <svg
              width='28'
              height='28'
              viewBox='0 0 28 28'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <title>check circle</title>
              <g filter='url(#filter0_d_21409_11506)'>
                <circle cx='13' cy='14' r='5' fill='white' />
              </g>
              <defs>
                <filter
                  id='filter0_d_21409_11506'
                  x='0'
                  y='0'
                  width='28'
                  height='28'
                  filterUnits='userSpaceOnUse'
                  colorInterpolationFilters='sRGB'
                >
                  <feMorphology
                    radius='1'
                    operator='dilate'
                    in='SourceAlpha'
                    result='effect1_dropShadow_21409_11506'
                  />
                  <feOffset />
                  <feComposite in2='hardAlpha' operator='out' />
                  <feColorMatrix
                    type='matrix'
                    values='0 0 0 0 0.0196078 0 0 0 0 0.588235 0 0 0 0 0.411765 0 0 0 1 0'
                  />
                  <feBlend
                    mode='normal'
                    in2='BackgroundImageFix'
                    result='effect1_dropShadow_21409_11506'
                  />
                  <feBlend
                    mode='normal'
                    in='SourceGraphic'
                    in2='effect1_dropShadow_21409_11506'
                    result='shape'
                  />
                </filter>
              </defs>
            </svg>
            <span className='sr-only'> {name}</span>
          </h4>,
        )}
      </Fragment>
    );
  }

  if (isComplete) {
    return (
      <Fragment>
        {renderLine(nextStepCompleted ? 'bg-green-600' : 'bg-blue-600')}
        {renderIcon(
          '',
          <h4 className='text-white text-sm font-medium text-center'>
            <div className='flex bg-green-600 justify-center items-center rounded-full size-[24px]'>
              <SnapIcon
                icon='check-circle'
                size='md'
                className='text-green-200'
              />
            </div>
            <span className='sr-only'> {name}</span>
          </h4>,
        )}
      </Fragment>
    );
  }

  if (isNextStep) {
    return (
      <Fragment>
        {renderLine(
          isCurrent && !nextStepCompleted ? 'bg-gray-300' : 'bg-blue-600',
        )}
        {renderIcon(
          classNames(
            'border border-blue-600',
            isCurrent ? 'bg-blue-600 text-white' : 'bg-blue-100 text-blue-500',
          ),
        )}
      </Fragment>
    );
  }
  return (
    <Fragment>
      {renderLine('bg-gray-300')}
      {renderIcon('border bg-white border-gray-300 text-gray-300')}
    </Fragment>
  );
};
